import React from 'react'
import {Container, Row, Col} from 'react-bootstrap'
import CategoryJson from 'json/category.json'
import './style.css'
import Judul from 'components/componentsmall/title'

export default function category() {
    return (
        <Container className="home-category">
            <Judul judul="Keuntungan menjadi Reseller" /> 
            <Row>           
                {
                    CategoryJson.map((data, i) => {
                        return (
                            <Col key={i} md={6} sm={6} xs={6}>
                                <div className="card">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src="asset/home/categories/img_category.png" className="img-fluid rounded-start" alt="category"/>
                                    </div>
                                    <div className="col-md-8">
                                        <div className="card-body">
                                        <h5 className="card-title">{data.title}</h5>
                                        <p className="card-text">{data.text_isi}</p>
                                        </div>
                                    </div>
                                </div>
                               </div>
                            </Col>
                        )
                    })
                }
            </Row>
        </Container>
    )
}
